import { render, staticRenderFns } from "./kpi-footer-summary.vue?vue&type=template&id=7dbcc888"
import script from "./kpi-footer-summary.vue?vue&type=script&lang=js"
export * from "./kpi-footer-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports